import React from 'react';
import styled from 'styled-components';

// 3D Pinball Space Cadet — locally hosted game files (no external iframe)
// Uses lrusso's JavaScript/WebAssembly port (auto-resizes to fit window)
// Source: https://github.com/lrusso/3DPinballSpaceCadet
// Files hosted from public/pinball/

function Pinball() {
    return (
        <Container>
            <iframe
                src="/pinball/3DPinballSpaceCadet.htm"
                title="3D Pinball for Windows - Space Cadet"
                frameBorder="0"
                allowFullScreen
                allow="autoplay"
                loading="lazy"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
            />
        </Container>
    );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  position: relative;
`;

export default Pinball;
